// src/pages/OrderPage.jsx
import { useTranslation } from 'react-i18next';
import OrderForm from '../components/OrderForm.jsx';

export default function OrderPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-pink-50 dark:bg-gray-900 p-6">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold text-center text-pink-700 dark:text-pink-300 mb-8">
          {t('order.pageTitle')}
        </h1>
        <OrderForm />
      </div>
    </div>
  );
}
